import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReportSheet = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M870.4 102.4h-214.016c-21.504-59.392-77.824-102.4-144.384-102.4s-122.88 43.008-144.384 102.4h-214.016c-56.32 0-102.4 46.080-102.4 102.4v716.8c0 56.32 46.080 102.4 102.4 102.4h716.8c56.32 0 102.4-46.080 102.4-102.4v-716.8c0-56.32-46.080-102.4-102.4-102.4zM512 102.4c28.16 0 51.2 23.040 51.2 51.2s-23.040 51.2-51.2 51.2c-28.16 0-51.2-23.040-51.2-51.2s23.040-51.2 51.2-51.2zM563.2 819.2h-256c-28.16 0-51.2-23.040-51.2-51.2s23.040-51.2 51.2-51.2h256c28.16 0 51.2 23.040 51.2 51.2s-23.040 51.2-51.2 51.2zM716.8 614.4h-409.6c-28.16 0-51.2-23.040-51.2-51.2s23.040-51.2 51.2-51.2h409.6c28.16 0 51.2 23.040 51.2 51.2s-23.040 51.2-51.2 51.2zM716.8 409.6h-409.6c-28.16 0-51.2-23.040-51.2-51.2s23.040-51.2 51.2-51.2h409.6c28.16 0 51.2 23.040 51.2 51.2s-23.040 51.2-51.2 51.2z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgReportSheet);
export default ForwardRef;
